module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/plan4-2-02dfb9ae4e505b610be565bf113b424e.webp";